import ErrorToken from './error-token';

export default ErrorToken;